import { api } from '@/api'
import { useQuery } from '@tanstack/react-query'

export type LanguageDictionaryItem = DictionaryItem & { iso1: string | null }
export type DictionaryItem = { code: string; name: string }
export type SelectOption = { value: string; label: string }

export const toSelectOptions = (items: { code: string; name: string }[]): SelectOption[] => {
  return items.map(({ code, name }) => ({ value: code, label: name }))
}

export const useCountries = () => {
  const query = useQuery({
    queryKey: ['CONFIGURATION_COUNTRIES'],
    queryFn: () => api.get<DictionaryItem[]>('/configuration/countries'),
    staleTime: 5 * 60 * 1000
  })
  const options = query.data ? toSelectOptions(query.data) : []
  return { ...query, options }
}

export const useLanguages = () => {
  const query = useQuery({
    queryKey: ['CONFIGURATION_LANGUAGES'],
    queryFn: () => api.get<LanguageDictionaryItem[]>('/configuration/languages'),
    staleTime: 5 * 60 * 1000
  })

  return { ...query, options: query.data || [] }
}
